var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge, Divider, ListItemIcon, ListItemText, MenuItem, } from '@material-ui/core';
import { Translate } from '@material-ui/icons';
import TranslationsModal from './TranslationsModal';
import { CentralProviderContext } from '../../centralProviderContext/CentralProviderContext';
export default function Index() {
    var t = useTranslation().t;
    var centralContext = useContext(CentralProviderContext);
    var _a = __read(useState(false), 2), modalOpen = _a[0], setModalOpen = _a[1];
    var translations = [];
    window.missingTranslations.forEach(function (value) {
        translations.push(value);
    });
    return ((translations.length && centralContext.hasFullAccountAccess('any'))
        ? (React.createElement(React.Fragment, null,
            (modalOpen)
                ? React.createElement(TranslationsModal, { onClose: function () { return setModalOpen(false); }, translations: translations })
                : null,
            React.createElement(MenuItem, { onClick: function () { return setModalOpen(true); } },
                React.createElement(ListItemIcon, { style: { minWidth: '33px' } },
                    React.createElement(Badge, { badgeContent: translations.length, variant: "dot", color: "error" },
                        React.createElement(Translate, { color: "primary" }))),
                React.createElement(ListItemText, { primary: t('Missing Translations') })),
            React.createElement(Divider, null)))
        : null);
}
//# sourceMappingURL=index.js.map